export enum AuthFlowType {
  EMAIL_ASSOCIATION = 'email-association',
  PHONE_ASSOCIATION = 'phone-association',
  PHONE_DEFINITION = 'phone-definition',
  EMAIL_DEFINITION = 'email-definition',
  PHONE_REGISTRATION_EMAIL_ASSOCIATION = 'phone-registration-email-association',
}

export enum FlowType {
  AUTH = 'auth',
  DEFINITION = 'definition',
}

export enum AuthStepType {
  VALIDATE_PASSWORD = 'validate-password',
  SET_PASSWORD = 'set-password',
  VERIFY_OTP = 'verify-otp',
  RECOVER_PIN = 'recover-pin',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  MFA_VALIDATION = 'mfa-validation'
}

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  type: FlowType,
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    input: string;
    inputAria: {
      required: string;
      notRequired?: string;
    }
    nextButton: string;
    skipButton?: string;
  },
  previousStepBackXTimes: number;
  identifierField: 'email' | 'phoneNumber';
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.EMAIL_ASSOCIATION]: {
    form: "validate_password__" + AuthFlowType.EMAIL_ASSOCIATION,
    flow: AuthFlowType.EMAIL_ASSOCIATION,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "email_association.header_title",
      headerSubtitle: "email_association.header_message",
      input: 'email_association.email_input',
      inputAria: {
        required: 'accessibility.phonenumber.registration.email_association.input.required',
        notRequired: 'accessibility.phonenumber.registration.email_association.input.not_required'
      },
      nextButton: 'email_association.button_next_message',
      skipButton: 'email_association.jump_next_button_message'
    },
    identifierField: 'email',
    previousStepBackXTimes: 1,
  },
  [AuthFlowType.PHONE_ASSOCIATION]: {
    form: "validate_password__" + AuthFlowType.PHONE_ASSOCIATION,
    flow: AuthFlowType.PHONE_ASSOCIATION,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "phonenumber_association.header_title",
      headerSubtitle: "phonenumber_association.header_message",
      input: 'phonenumber_association.phone_title',
      inputAria: {
        required: 'accessibility.email.registration.phonenumber_association.input_required',
        notRequired: 'accessibility.email.registration.phonenumber_association.input'
      },
      nextButton: 'phonenumber_association.button_next_message',
      skipButton: 'phonenumber_association.jump_next_button_message'
    },
    identifierField: 'phoneNumber',
    previousStepBackXTimes: 1,
  },
  [AuthFlowType.PHONE_DEFINITION]: {
    form: "validate_password__" + AuthFlowType.PHONE_DEFINITION,
    flow: AuthFlowType.PHONE_DEFINITION,
    type: FlowType.DEFINITION,
    labels: {
      headerTitle: "phonenumber_association.header_title",
      headerSubtitle: "phonenumber_association.header_message",
      input: 'phonenumber_association.phone_title',
      inputAria: {
        required: 'accessibility.email.registration.phonenumber_association.input_required',
        notRequired: 'accessibility.email.registration.phonenumber_association.input'
      },
      nextButton: 'phonenumber_association.button_next_message'
    },
    identifierField: 'phoneNumber',
    previousStepBackXTimes: 1,
  },
  [AuthFlowType.EMAIL_DEFINITION]: {
    form: "validate_password__" + AuthFlowType.EMAIL_DEFINITION,
    flow: AuthFlowType.EMAIL_DEFINITION,
    type: FlowType.DEFINITION,
    labels: {
      headerTitle: "site_credentials.email_association.definition.header_title",
      headerSubtitle: "site_credentials.email_association.definition.header_message",
      input: 'email_association.email_input',
      inputAria: {
        required: 'accessibility.email.registration.phonenumber_association.input_required'
      },
      nextButton: 'phonenumber_association.button_next_message'
    },
    identifierField: 'email',
    previousStepBackXTimes: 1,
  },
  [AuthFlowType.PHONE_REGISTRATION_EMAIL_ASSOCIATION]: {
    form: "validate_password__" + AuthFlowType.PHONE_REGISTRATION_EMAIL_ASSOCIATION,
    flow: AuthFlowType.PHONE_REGISTRATION_EMAIL_ASSOCIATION,
    type: FlowType.AUTH,
    labels: {
      headerTitle: "email_association.header_title",
      headerSubtitle: "email_association.header_message",
      input: 'email_association.email_input',
      inputAria: {
        required: 'accessibility.phonenumber.registration.email_association.input.required',
        notRequired: 'accessibility.phonenumber.registration.email_association.input.not_required'
      },
      nextButton: 'email_association.button_next_message',
      skipButton: 'email_association.jump_next_button_message'
    },
    identifierField: 'email',
    previousStepBackXTimes: 2,
  },
}